/**
 * Pingo §3.8 / G19 — Quick-ATC delegation on product cards.
 *
 * When a `[data-pingo-quick-atc]` button is clicked, delegate to the
 * hidden native `<quick-add-component>` inside the same `<product-card>`.
 * Horizon's server-side bifurcation (`data-quick-add-button`) picks
 * the active native path:
 *   - "add"    → form submit → CartAddEvent → cart drawer (product-form.js)
 *   - "choose" → quick-add-component.handleClick → native modal
 *
 * Zero cart-logic re-implementation — the native path fires untouched.
 * Visible click animation rides on `.add-to-cart-button[data-added='true']`
 * (Horizon base.css cascade).
 */

(function () {
  if (window.__pingoCardAtcInit) return;
  window.__pingoCardAtcInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element ? event.target.closest('[data-pingo-quick-atc]') : null;
    if (!btn || btn.disabled) return;

    event.preventDefault();

    // Re-entrancy guard: 800ms matches the native animation reset window
    // (product-form.js ~line 159).
    if (btn.dataset.added === 'true') return;

    // Synchronous visual feedback FIRST — before any DOM lookup or delegation.
    // On the single-variant path the native animation cascade lands inside the
    // cart drawer (not on our button); setting data-added here guarantees the
    // checkmark-burst fires on the clicked element regardless.
    btn.dataset.added = 'true';
    var clearAdded = setTimeout(function () {
      btn.removeAttribute('data-added');
    }, 800);

    var card = btn.closest('product-card');
    var quickAdd = card ? card.querySelector('quick-add-component') : null;
    // Horizon decides add-vs-choose server-side (snippets/quick-add.liquid)
    // and toggles visibility via this attribute. Pick the active button.
    var mode = quickAdd ? quickAdd.getAttribute('data-quick-add-button') || 'choose' : null;
    var selector = mode === 'add' ? '.quick-add__button--add' : '.quick-add__button--choose';
    var nativeBtn = quickAdd ? quickAdd.querySelector(selector) : null;

    if (!nativeBtn || nativeBtn.disabled) {
      clearTimeout(clearAdded);
      btn.removeAttribute('data-added');
      console.warn('[pingo-card-atc] Native quick-add button not found');
      return;
    }

    // Programmatic click — works even when the native wrapper is display:none,
    // because .click() bypasses hit-testing but still dispatches the click
    // event Horizon's delegated handlers listen for.
    nativeBtn.click();
  });
})();
